import { CustomerState } from '../state';
import { PayloadAction } from '@reduxjs/toolkit';
import { CustomerSubscription } from '@hiwaldo/sdk/interfaces';

export const updateCustomerSubscriptionReducer = (
  state: CustomerState,
  action: PayloadAction<CustomerSubscription>
) => {
  state.customer!.customerSubscriptions = [action.payload];
};
